.iframe {
  min-height: 230px;
  padding: 0;
}

.iframe.ready {
  padding: var(--mirai-ui-space-M) var(--mirai-ui-space-M) 0 var(--mirai-ui-space-M);
}

.form {
  padding: 0 var(--mirai-ui-space-M) 0 var(--mirai-ui-space-M);
}

.form .required {
  padding-left: var(--mirai-ui-space-XXS);
  color: var(--mirai-ui-error);
}

.form > ui-text {
  margin-bottom: var(--mirai-ui-space-XXS);
}

.form input,
.form select {
  border: var(--mirai-ui-input-text-border);
  border-radius: var(--mirai-ui-border-radius);
  border-width: var(--mirai-ui-border-width);
  font-size: var(--mirai-ui-font-size-action);
  line-height: var(--mirai-ui-line-height-paragraph);
  padding: var(--mirai-ui-space-XS);
  margin-bottom: var(--mirai-ui-space-S);
}

.button {
  margin: var(--mirai-ui-space-XXS) var(--mirai-ui-space-M) var(--mirai-ui-space-M) var(--mirai-ui-space-M);
}
